// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayNumber-moduleCalendarGridDayNumber__xp5YZ";
export { _1 as "CalendarGridDayNumber" }
